import { useState } from "react";

function DoctorMinistryAccordion({ accordions, showRequestInfo=null}) {

    const [localAccordions, setLocalAccordions] = useState(accordions.map((el) => {return {...el, open: false}}));

	const toggleItem = (accordions, index) => {
		setLocalAccordions(accordions.map((accordion, i) => {
			if (i === index) {
				accordion.open = !accordion.open
			}
			return accordion;
		}));
	}

	const clickHandler = ($event) => {
		const el = $event.target.closest('a');
		if (el && $event.currentTarget.contains(el)) {
			showRequestInfo && el && el.id && el.id === "request_info_btn" ? showRequestInfo() : null;
		}
	}

	return (
		<div className="accordians">
			{ localAccordions.map((accordion, i) => (
				<div className={"accordian " + (accordion.open ? 'open' : '')} key={i} onClick={() => toggleItem(accordions, i)}>
					<div className="accordion-question">
						{accordion.heading}
					</div>
					<div className="accordion-answer w3-animate-zoom">
						<div onClick={clickHandler} className="rsvp-body-text">
                               {accordion?.subHeading && <h3>{accordion.subHeading}</h3>}
                               {accordion?.content && <p>{accordion?.content}</p>}
                           </div>
					</div>
				</div>
            ))}
        </div>
	);
}

export default DoctorMinistryAccordion;